import { render, staticRenderFns } from "./Kb.vue?vue&type=template&id=44e1ff44&scoped=true&"
import script from "./Kb.vue?vue&type=script&lang=ts&"
export * from "./Kb.vue?vue&type=script&lang=ts&"
import style0 from "./Kb.vue?vue&type=style&index=0&id=44e1ff44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1ff44",
  null
  
)

export default component.exports